import { useTranslation } from "react-i18next";
import moment from "moment/moment";

import { IconButton } from "@mui/material";
import { formatDate } from "utils/formatDate";
import { ImageOutlined } from "@mui/icons-material";

const NotificationTable = (notifications = [], openImagePreview) => {
  const { t } = useTranslation();

  const columns = [
    { field: "id", headerName: "No", width: 200, hide: false },
    { field: "target", headerName: t("fields.target"), width: 200 },
    { field: "type", headerName: t("fields.type"), width: 200 },
    { field: "title", headerName: t("fields.title"), width: 200 },
    { field: "message", headerName: t("section_11.message"), width: 200 },
    { field: "createdAt", headerName: t("fields.createdAt"), width: 250 },

    {
      field: "image",
      headerName: t("fields.image"),
      width: 100,
      renderCell: (param) => (
        <IconButton onClick={() => openImagePreview(param.value)}>
          {/* <ImageOutlined/> */}
          <svg
            width="23"
            height="23"
            viewBox="0 0 23 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_106_12727)">
              <path
                d="M22.9914 11.5022C22.9914 13.2097 23.0022 14.9172 22.9878 16.6246C22.9777 17.8179 22.7307 18.9622 22.1429 20.0122C21.1994 21.6973 19.7021 22.5687 17.8431 22.8769C17.3844 22.9533 16.9148 22.9922 16.4495 22.9936C13.0536 23.0008 9.65766 23.008 6.26175 22.9857C5.0035 22.9778 3.80287 22.6738 2.729 21.9911C1.09622 20.9527 0.302525 19.3979 0.0763706 17.5226C0.0165911 17.025 0.00578752 16.5188 0.00506728 16.0168C-0.00141484 12.9432 0.00578752 9.86967 2.56359e-05 6.79681C-0.00213507 5.68058 0.131829 4.59028 0.576934 3.55903C1.39728 1.65713 2.88097 0.578353 4.87746 0.180113C5.4198 0.0720909 5.98158 0.0137591 6.53472 0.0108786C9.8759 -0.00352435 13.2185 7.63813e-05 16.5604 0.00727783C17.6969 0.00943827 18.7931 0.227642 19.8115 0.749748C21.6085 1.67081 22.5484 3.20472 22.8689 5.14911C22.9604 5.70435 22.9856 6.2747 22.9914 6.8393C23.0072 8.39409 22.9971 9.94888 22.9971 11.503C22.995 11.503 22.9935 11.503 22.9914 11.503V11.5022ZM2.1312 18.5791C2.23204 18.5143 2.31558 18.4624 2.39697 18.4077C3.71644 17.5219 5.03735 16.639 6.35394 15.7497C6.98271 15.3248 7.66405 15.1872 8.40517 15.3363C8.94535 15.445 9.36813 15.759 9.7693 16.1119C10.164 16.459 10.6177 16.6765 11.1435 16.7363C11.9271 16.8248 12.6099 16.6109 13.2099 16.0917C14.7519 14.7573 16.2968 13.4272 17.8518 12.1079C18.7982 11.3056 20.096 11.2898 21.0806 12.0387C21.1317 12.0776 21.1894 12.1064 21.2722 12.1568C21.2722 12.0251 21.2722 11.9358 21.2722 11.8465C21.2722 10.1664 21.2765 8.48627 21.2693 6.80617C21.2679 6.40289 21.2549 5.99601 21.2002 5.59704C20.9754 3.95943 20.2106 2.70926 18.6044 2.09138C17.9346 1.83429 17.2353 1.72987 16.5201 1.72915C13.1875 1.72698 9.85501 1.72626 6.52248 1.73059C6.20918 1.73059 5.89299 1.75219 5.58329 1.79684C4.00382 2.02296 2.77365 2.74671 2.13768 4.28206C1.88416 4.89346 1.74732 5.53727 1.743 6.19693C1.72931 8.70375 1.72931 11.2106 1.72859 13.7174C1.72859 14.7508 1.72283 15.7842 1.7466 16.8169C1.761 17.4189 1.89136 18.0051 2.1312 18.5784V18.5791Z"
                fill="#A4A4A4"
              />
              <path
                d="M8.04339 9.63071C6.52873 9.62711 5.29857 8.39206 5.30866 6.88624C5.31874 5.37537 6.5525 4.15761 8.06788 4.16409C9.56453 4.17057 10.7875 5.39842 10.7896 6.89632C10.7911 8.40718 9.55949 9.63431 8.04411 9.63071H8.04339Z"
                fill="#A4A4A4"
              />
            </g>
            <defs>
              <clipPath id="clip0_106_12727">
                <rect width="23" height="23" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </IconButton>
      ),
    },
  ];

  const rows =
    notifications.length === 0
      ? []
      : [
          ...notifications.map((notification, index) => ({
            id: index + 1,
            target: notification["target"],
            type: notification["type"],
            title: notification?.notification["title"],
            message: notification?.notification["body"],
            createdAt: formatDate(notification["createdAt"]),
            image: notification?.notification["image"],
          })),
        ];

  return { rows, columns };
};

export default NotificationTable;
